import styled from 'styled-components';

export const FormReceipt = styled.form`
  display: grid;
  /* Deux colonnes : champs à gauche, pavé numérique à droite */
  grid-template-columns: 1fr 240px;
  column-gap: 16px;
  row-gap: 12px;
  max-width: 800px;
  position: relative;

  /* Tous les champs par défaut dans la première colonne */
  & > *:not(.numpad-grid) {
    grid-column: 1;
  }

  /* Pavé numérique positionné absolument pour remplir la colonne droite */
  & > .numpad-grid {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 240px;
    display: grid;
    grid-template-rows: repeat(4, 1fr);
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    padding: 8px;
    background: ${({ theme }) => theme.colors.surface};
  }
`;

export default FormReceipt;
